import React from "react"
import PropTypes from "prop-types"
import VerifyField from "../../../../components/misc/VerifyField"

const utils = require("../../../../helpers/utils")
const api = require("../../../../api")
const i9Actions = require("../../../../actions/I9Actions")

const styles = {
    paper: {
        textAlign: "left",
        padding: 30,
        margin: 20
    },
    cardContainer: {
        textAlign: "center",
        width: "100%"
    }
}

const propTypes = {
    i9: PropTypes.object,
    onValueChange: PropTypes.func
}

export default class I9Name extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            i9: null
        }
        this.onFirstNameChange = this.onFirstNameChange.bind(this)
        this.onMiddleInitialChange = this.onMiddleInitialChange.bind(this)
        this.onLastNameChange = this.onLastNameChange.bind(this)
        this.onOtherNameChange = this.onOtherNameChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.i9) {
            const _this = this

            this.setState({
                i9: nextProps.i9
            })
        }
    }

    getFirstName() {
        return this.state.i9 ? this.state.i9.Employee_FirstName : ""
    }

    getFirstNameHint() {
        if (this.state.i9) {
            if (this.state.i9.UserDataHint) {
                return this.state.i9.UserDataHint.FirstName
            }
        }

        return ""
    }

    getLastName() {
        return this.state.i9 ? this.state.i9.Employee_LastName : ""
    }

    getLastNameHint() {
        if (this.state.i9) {
            if (this.state.i9.UserDataHint) {
                return this.state.i9.UserDataHint.LastName
            }
        }

        return ""
    }

    getMiddleInitial() {
        return this.state.i9 ? this.state.i9.Employee_MiddleInitial : ""
    }

    getOtherName() {
        return this.state.i9 ? this.state.i9.Employee_OtherNames : ""
    }

    onFirstNameChange(value) {
        this.state.i9.Employee_FirstName = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_FirstName: value
        })
    }

    onMiddleInitialChange(value) {
        this.state.i9.Employee_MiddleInitial = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_MiddleInitial: value
        })
    }

    onLastNameChange(value) {
        this.state.i9.Employee_LastName = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_LastName: value
        })
    }

    onOtherNameChange(value) {
        this.state.i9.Employee_OtherNames = value
        this.updateI9()
        i9Actions.patchSection1Data(this.state.i9.I9Id, {
            Employee_OtherNames: value
        })
    }

    updateI9() {
        if (this.props.onValueChange) {
            this.props.onValueChange(this.state.i9)
        }
    }

    validate(i9) {
        if (!i9) {
            return false
        }

        if (!i9.Employee_FirstName || i9.Employee_FirstName.length === 0 || !i9.Employee_LastName || i9.Employee_LastName.length === 0) {
            return false
        } else {
            return true
        }
    }

    render() {
        return (
            <div className="I9Name">
                <b>Name Information</b>
                <VerifyField
                    autoFocus={true}
                    floatingLabelText="First Name (Given Name)"
                    value={this.getFirstName()}
                    hintValue={this.getFirstNameHint()}
                    onValueChange={this.onFirstNameChange}
                    style={{ width: "100%", marginTop: 10 }}
                    confirmQuestion={"Is <b>{0}</b> your full legal first name?"}
                />
                <VerifyField
                    floatingLabelText="Middle Initial"
                    value={this.getMiddleInitial()}
                    onValueChange={this.onMiddleInitialChange}
                    style={{ width: "100%" }}
                    innerStyle={{ marginTop: 20 }}
                    confirmQuestion={"Is <b>{0}</b> your middle initial?"}
                />
                <VerifyField
                    floatingLabelText="Last Name (Family Name)"
                    value={this.getLastName()}
                    hintValue={this.getLastNameHint()}
                    onValueChange={this.onLastNameChange}
                    style={{ width: "100%" }}
                    innerStyle={{ marginTop: 20, marginBottom: 20 }}
                    confirmQuestion={"Is <b>{0}</b> your full legal last name?"}
                />
                <VerifyField
                    floatingLabelText="Other Names Used (if any)"
                    style={{ width: "100%" }}
                    value={this.getOtherName()}
                    onValueChange={this.onOtherNameChange}
                    innerStyle={{ marginTop: 20, marginBottom: 20 }}
                    confirmQuestion={"Do you also go by <b>{0}</b>?"}
                />
            </div>
        )
    }
}

I9Name.propTypes = propTypes
